import React from 'react'
import PropTypes from 'prop-types'

const ReportsIcon = ({ style, width = 20, height = 20 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    style={style}
    width={width}
    height={height}
    viewBox="0 0 20 20"
  >
    <g fill="#FFF" fillRule="nonzero">
      <path d="M11 4v6h6c0-3.313-2.687-6-6-6zm1.142 1.28a4.872 4.872 0 0 1 3.578 3.578h-3.578V5.28z" />
      <path d="M9.997 17A6.002 6.002 0 0 0 16 11h-6V5a6 6 0 0 0-6 6 6 6 0 0 0 5.997 6z" />
    </g>
  </svg>
)

ReportsIcon.propTypes = {
  style: PropTypes.object,
  width: PropTypes.number,
  height: PropTypes.number,
}

export default ReportsIcon
